module.exports = __webpack_public_path__ + "fa-brands-400.svg?0c46be99b3b379291cbeff43aeeb206e";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fortawesome/fontawesome-free-webfonts/webfonts/fa-brands-400.svg
// module id = 661
// module chunks = 3